<template>
  <div class="trApplyRefund linear-main3">
    <ld-header
      transparent
      white
    >
      {{ $t('B020','申请退票') }}
    </ld-header>

    <div
      class="pad8"
      v-if="detail.orderId"
    >
      <!-- 原订单信息 -->
      <div class="round-sm bg-white pad8 pb0">
        <stop-station
          class="van-hairline--bottom"
          :detail="detail"
          train-no-class="main-color"
        />
        <van-row class="font12 pad8 bg-white text-center">
          <router-link
            to="/tr/OrderService"
            class="main-color"
          >
            {{ $t('F010','退改签规则') }}
          </router-link>
        </van-row>
      </div>

      <!-- 乘机人列表 -->
      <div class="mt5">
        <van-checkbox-group v-model="CheckPsgList">
          <van-cell-group>
            <van-cell class="font-bold">
              <h3>请选择需要退票的乘客</h3>
            </van-cell>
            <van-cell
              v-for="(psg, i) in detail.psgList"
              clickable
              :key="psg.id"
              @click="checkBoxes(psg, i)"
            >
              <div slot="title">
                {{ psg.passengerName }}&nbsp;({{ psg.idCode ? psg.idCode.replace(/^(.{4})(?:\w+)(.{4})$/,
                                                                                 "\$1******\$2") : "" }})
                <van-tag plain>
                  {{ psg.ticketTypeName }}
                </van-tag>
                <van-tag
                  v-if="psg.showRefundTag"
                  type="danger"
                >
                  已申请退票
                </van-tag>
                <van-tag
                  v-else-if="psg.showChangeTag"
                  type="success"
                >
                  已申请改签
                </van-tag>
              </div>

              <div slot="label">
                <van-row type="flex">
                  <van-col class="text-right">
                    {{ $t('F008','手机号') }}：
                  </van-col>
                  <van-col span="20">
                    {{ psg.phoneNumber }}
                  </van-col>
                </van-row>

                <van-row type="flex">
                  <van-col class="text-right">
                    席&nbsp;&nbsp;&nbsp;&nbsp;位：
                  </van-col>
                  <van-col span="20">
                    {{ psg.seatCode }}
                    {{ psg.seatTypeName }}
                  </van-col>
                </van-row>

                <van-row type="flex">
                  <van-col class="text-right">
                    费&nbsp;&nbsp;&nbsp;&nbsp;用：
                  </van-col>
                  <van-col
                    span="20"
                    class="orange"
                  >
                    {{ psg.ticketPriceStr }}
                  </van-col>
                </van-row>
              </div>

              <van-checkbox
                v-show="psg.abledRefund"
                :name="psg"
                ref="checkboxes"
                slot="right-icon"
              />
            </van-cell>
            <van-cell v-if="CheckPsgList.length > 0">
              <span
                class="font12 gray"
                slot="title"
              >
                预计退票手续费 <span class="orange">&yen; {{ refundAmount }}</span>
              </span>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </div>

      <!-- 企业退票原因 -->
      <van-cell
        class="mt5"
        title="企业退票原因(必填)"
      />
      <van-field
        class="m-b-5"
        is-link
        readonly
        v-model="refundReasonVip"
        placeholder="选择企业退票原因"
        @click="$refs['refundReason'].toggle()"
      />

      <ld-uploader
        class="mt5 round-sm overflow"
        v-if="detail.orderId"
        :order-id="detail.orderId"
        :glywlx="'11010'"
        :cjlx="2"
      />
    </div>


    <!--提交申请-->
    <ld-tabbar
      class="pad8"
      style="height: auto;"
    >
      <ld-button
        orangeRed
        round
        :disabled="!canSubmit"
        @click="toApplyRefund"
      >
        {{ $t('B020','申请退票') }}
      </ld-button>
    </ld-tabbar>

    <!-- 企业退票原因列表 -->
    <!-- <CancelReason
      ref="refundReason"
      title="选择退票原因"
      :par-no="143"
      @selected="reasonSelect"
    /> -->
    <CancelReason
      ref="refundReason"
      title="选择退票原因"
      :par-no="11603044"
      @selected="reasonSelect"
    />
  </div>
</template>

<script>
/**
 * @copyright (C), 2018-2019
 * @file 火车票申请退票页面
 * @desc
 * @param {String} id 火车票订单
 */

import { CellGroup, Cell, CheckboxGroup, Checkbox, Field, Tag } from 'vant'
import ldButton from 'Common/ldButton'
import CancelReason from 'Components/CancelReason'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import StopStation from '../trQuery/StopStation'
import Bussiness from 'Utils/business'
import ldUploader from 'Components/ldUploader'

import { getSysType } from 'CommonUtils/plus.js'
import TrainOrderInteractor from 'Domain/use-cases/train-order-interactor'
import mixin from '../mixin'

export default {
  name: 'ApplyRefund',
  mixins: [mixin],
  components: {
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [Tag.name]: Tag,
    ldButton,
    CancelReason,
    ldTabbar,
    StopStation,
    ldUploader
  },
  data() {
    return {
      detail: {},
      refundReasonVip: '',
      CheckPsgList: [],
      canSubmit: false,
    }
  },
  async created() {
    this.getPsg()
  },
  methods: {
    checkBoxes (psg, i) {
      if (psg.abledRefund) {
        this.$refs['checkboxes'][i].toggle()

        this.detail.psgList.forEach((psg, j) => {
          if (psg.idCode === this.detail.psgList[i].idCode) {
            this.$refs['checkboxes'][j].toggle()
          }
        })
      }
    },
    /**
     * 获取可退票的乘机人
     */
    async getPsg() {
      this.isLoading = true

      const { data = {} } = await TrainOrderInteractor.getRefundPsgList(
        this.$route.query.id,
        this.$route.query.applyType
      )

      this.isLoading = false

      this.detail = data

      this.validAccount(this.detail.orderId)

      // 如果订单中只有一个乘客，默认的勾选上
      this.$nextTick(() => {
        if (this.detail.psgList && this.detail.psgList.length === 1) this.checkBoxes(this.detail.psgList[0], 0)
      })
    },
    /**
     * 选择企业退票原因
     */
    reasonSelect (reason) {
      this.refundReasonVip = reason.cName
    },
    /**
     * 提交退票申请
     */
    async toApplyRefund () {
      try {
        let params = {
          orderFrom: getSysType(),
          refundReasonVip: this.refundReasonVip,
          orderId: this.detail.orderId,
          ticketList: this.CheckPsgList.map(travel => {
            return {
              ticketId: travel.id,
              ticketType: travel.changeStatus == 1 ? 2 : 1
            }
          })
        }

        const { ids } = await TrainOrderInteractor.submitRefund(params)

        if (ids.length === 1) {
          this.$router.push(`/tr/RefundCmp/${ids[0]}`)
        } else {
          this.$dialog({
            confirmButtonText: '前往',
            message: '系统生成两个订单前往订单列表查看',
          }).then(() => {
            this.$router.push({
              path: '/allOrder?findType=1',
              query: { findType: '4' }
            })
          })
        }
      } catch (error) {
        if (typeof error === 'string') this.$dialog.alert({ message: error })
      }
    }
  },
  computed: {
    refundAmount: vm => Bussiness.ComputedRefundAmount(vm.detail, vm.CheckPsgList)
  }
}
</script>

<style lang="less">
.trApplyRefund {

  h3 {
    margin: 0;
  }

  padding-bottom: 60%;

  .pad8 {
    padding: 8px;
  }
  .pb0 {
    padding-bottom: 0;
  }
  .mt5 {
    margin-top: 5px;
  }

  .StopStation {
    > .van-row {
      color: @color-text-black;
    }
  }

  .query-btn {
    width: 85px;
  }

  .calender-icon {
    font-size: 18px;
    line-height: 24px;
    margin-right: 5px;
  }
}
</style>
